import { render } from "./ModalRackShared.vue?vue&type=template&id=2ccd1876"
import script from "./ModalRackShared.vue?vue&type=script&lang=js"
export * from "./ModalRackShared.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__